'use client'

import UIFlex from '@components/ui/UIFlex'
import UIText from '@components/ui/UIText'
import { pxToRem } from '@ui/style/muiTheme'
import zIndexes from '@ui/style/zIndexes.theme'
import color from '@ui/style/color.theme'
import UIContainer from '@components/ui/UIContainer'
import { JTBCLogo, JTBCLogoArea, NEWSLogo } from '@components/layout/Header/NavBox/styled'
import { ArticleResponseVo } from '@schemas/non-auth'
import { useIsAppControl } from '@store/isApp'
import TitleHeaderUtility from '../TitleHeaderUtility'

interface TitleHeaderProps {
	article: ArticleResponseVo
	className?: string
	scrap?: boolean
	commentVisible: boolean
	setScrap: (value: boolean) => void
}

const TitleHeader = ({ article, className, scrap, commentVisible, setScrap }: TitleHeaderProps) => {
	const { isApp } = useIsAppControl()
	const { articleTitle, articleMobileTitle } = article
	return (
		<UIFlex
			className={className}
			zIndex={zIndexes.header + 2}
			width="100%"
			position="fixed"
			top="0"
			left="0"
			sx={{
				background: color.colWhite,
				opacity: 0,
				height: 0,
				visibility: 'hidden',
				'&.is-pinned': {
					height: 'auto',
					opacity: 1,
					visibility: 'visible',
				},
			}}
		>
			<UIFlex className="TitleHeader-body">
				<UIContainer
					pr={{ xs: pxToRem(12), md: pxToRem(24), lg: pxToRem(48), xl: pxToRem(32) }}
				>
					<UIFlex
						flexDirection="row"
						alignItems="center"
						height={{ xs: pxToRem(52), md: pxToRem(84) }}
					>
						<JTBCLogoArea
							sx={{
								display: { xs: 'none', md: 'flex' },
								padding: {
									xl: `0 ${pxToRem(2.125)} ${pxToRem(21)} 0`,
								},
							}}
						>
							<JTBCLogo
								href={isApp ? '/' : process.env.NEXT_PUBLIC_JTBC_URL}
								sx={{
									'&': {
										width: pxToRem(66.7),
										height: pxToRem(34),
										backgroundSize: `${pxToRem(66.7)} ${pxToRem(34)}`,
									},
								}}
							>
								<UIText readonly>JTBC</UIText>
							</JTBCLogo>
							<NEWSLogo
								href="/"
								sx={{
									'&': {
										width: pxToRem(67),
										height: pxToRem(16.2),
										backgroundSize: `${pxToRem(67)} ${pxToRem(16.2)}`,
									},
								}}
							>
								<UIText readonly>NEWS</UIText>
							</NEWSLogo>
						</JTBCLogoArea>
						<UIText
							fontSize={{ xs: pxToRem(16), md: pxToRem(18) }}
							textAlign={{ xs: 'left', md: 'center' }}
							lineHeight={pxToRem(24)}
							fontWeight={700}
							flexGrow="1"
							sx={{
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								whiteSpace: 'nowrap',
								marginLeft: {
									md: pxToRem(32),
								},
							}}
						>
							<UIText
								component="span"
								sx={
									articleMobileTitle
										? { display: { xs: 'none', md: 'inline' } }
										: {}
								}
							>
								{articleTitle}
							</UIText>
							{articleMobileTitle && (
								<UIText
									component="span"
									sx={{ display: { xs: 'inline', md: 'none' } }}
								>
									{articleMobileTitle}
								</UIText>
							)}
						</UIText>
						<TitleHeaderUtility
							article={article}
							scrap={scrap}
							commentVisible={commentVisible}
							setScrap={setScrap}
						/>
					</UIFlex>
				</UIContainer>
			</UIFlex>
		</UIFlex>
	)
}

export default TitleHeader
